export const resumeLimit = 10;
